/** @jsxImportSource theme-ui */
import React from 'react';

import { BdIcon } from 'components/_common/BdIcon';
import { Typography } from 'components/_common/Typography';

const NotFoundMessage: React.FC<{ text: string; subText?: string; hintText?: string }> = ({
  text,
  subText = null,
  hintText = null,
}) => (
  <div
    sx={{
      textAlign: 'center',
      py: '64px',
    }}
  >
    <div sx={{ fontSize: '20px' }}>
      <BdIcon name="icon-search" color="deepSea50" />
      {/* <BdIcon name="icon-close" color="deepSea50" sx={{
        '&.icon.bd-icon': {
          fontSize: '7px',
          ...valignHackTop('-7px'),
          right: '17px',
        }
      }}/> */}
    </div>
    <Typography variant="subtitle2" color="deepSea50">
      {text}
    </Typography>
    {subText?.length && (
      <Typography variant="caption" color="deepSea50" sx={{ mt: '12px' }}>
        {subText}
      </Typography>
    )}
    {hintText?.length && (
      <Typography variant="caption" color="deepSea50" sx={{ mt: '12px' }}>
        <Typography variant="caption2" color="deepSea50" inline>
          Hint:{' '}
        </Typography>
        {hintText}
      </Typography>
    )}
  </div>
);

export default NotFoundMessage;
